import React from 'react';
import { styled } from "../stitches.config";
import Link from "../components/Link";
import { bodyLarge } from "./commonStyles/Fonts";
import HomeIcon from "./assets/icons/home-icon.svg";
import { useStores } from "../helpers";

type CtaButtonProps = {
    brand?: Config.Brand;
};

export const CtaButton: React.FC<CtaButtonProps> = ({
    brand = window.BRAND,
}) => {

    const config = window.APP_SETTINGS.cta_button;

    const { UIStore } = useStores();
    const isMaterialPartnera = UIStore.isMaterialPartnera;
    const isAd = (config?.ad == 1 ? true : false)
    const defaultName = (
        <>
            Więcej ciekawych artykułów znajdziesz na stronie głównej
            {brand === "dadhero" && " dadHERO.pl"}
            {brand === "natemat" && " natemat.pl"}
            {brand === "aszdziennik" && " ASZdziennik.pl"}
            {brand === "innpoland" && " INNPoland.pl"}
            {brand === "topnewsy" && " TopNewsy.pl"}
        </>
    );

    return (
        <>
            {isMaterialPartnera && isAd ?
                <StyledCtaButton className={bodyLarge()}>
                    <Link data-analytics-name="article-cta-btn" to={"/"}>
                        <StyledHomeIcon />
                        {defaultName}
                    </Link>
                </StyledCtaButton>
                :
                <StyledCtaButton className={bodyLarge()}>
                    {isAd && <AdLabel>Reklama.</AdLabel>}
                    {config?.target ?
                        <a data-analytics-name="article-cta-btn" href={config?.link || "/"} target={config?.target}>
                            {config?.icon ?
                                <StyledIcon src={config.icon} />
                                :
                                <StyledHomeIcon />
                            }
                            {config?.name || defaultName}
                        </a>
                        :
                        <Link data-analytics-name="article-cta-btn" to={config?.link || "/"}>
                            {config?.icon ?
                                <StyledIcon src={config.icon} />
                                :
                                <StyledHomeIcon />
                            }
                            {config?.name || defaultName}
                        </Link>
                    }
                </StyledCtaButton>
            }
        </>
    )
};


const StyledCtaButton = styled('div', {
    "a": {
        width: "100%",
        margin: "0 auto 18px auto",
        color: "$grayscale0Fixed !important",
        backgroundColor: "$primary",
        border: "2px solid $primary",
        cursor: "pointer",
        padding: "7px 16px 9px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "$primary120",
            border: "2px solid $primary120",
        },
    }
})

const StyledHomeIcon = styled('div', {
    display: "flex",
    marginRight: "16px",
    width: "16px",
    height: "17px",
    backgroundImage: `url("${HomeIcon}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    flexShrink: 0,
});

const StyledIcon = styled('img', {
    marginRight: "16px",
    width: "20px",
    height: "20px",
    flexShrink: 0,
});

const AdLabel = styled('div', {
    fontSize: "11px",
    color: "#a5a5a5",
    background: "#e3e3e3",
    padding: "2px 6px",
    lineHeight: "20px",
    maxWidth: "60px",
    "&:hover": {
        textDecoration: "none !important",
        color: "#a5a5a5",
    }
});

export default CtaButton